import request from '../utils/request';
//继续教育
export function toJxjyClassList(data) {
  return request({
    url: '/wap/learning/toJxjyClassList.do',
    method: 'post',
    data
  })
}

//职业培训
export function toZypxCourseList(data) {
  return request({
    url: '/wap/learning/toZypxCourseList.do',
    method: 'post',
    data
  })
}

//课程页面
export function toMyClassCourse(data) {
  return request({
    url: '/wap/learning/toMyCourseList.do',
    method: 'post',
    data
  })
}
export function ylxAddOrder(data) {
  return request({
    url: 'wap/learning/ylxAddOrder',
    method: 'post',
    data
  })
}

//章节页面
export function toStudyMain(data) {
  return request({
    url: '/wap/learning/toJxjyStudyMain.do',
    method: 'post',
    data
  })
}

//视频详情
export function toStudy(data) {
  return request({
    url: '/wap/learning/toJxjyStudy.do',
    method: 'post',
    data
  })
}

//记录学时
export function updateDBTrack(data) {
  return request({
    url: '/wap/learning/updateDBTrackJxjy.do',
    method: 'post',
    data
  })
}

//获取用户买课状态
export function toAllReadyBuy(data) {
  return request({
    url: '/wap/tyOrder/toAllReadyBuy.html',
    method: 'post',
    data
  })
}
//中经网一路学课程通过id查
export function toVideoUrl(data) {
  return request({
    url: '/web/toVideoUrl.html',
    method: 'post',
    data
  });
}
//x
// export function ylxAddOrder(data) {
//   return request({
//     url: '/wap/learning/ylxAddOrder',
//     method: 'post',
//     data
//   })
// }